import { Questions } from './add_questions';
import { Steps } from './steps';
import './pult.css';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { get_eventId } from './helpers';
import { Statistics } from './statistics';

export const Pult = () => {
    const location = useLocation();
    const event_id = get_eventId(location);
    const [config,toggleConfig] = useState(false);

    return <>
{/*         <Statistics event_id={event_id} /> */}
        <div className="two-columns">
            <Steps basic={false} config={config} toggleConfig={toggleConfig} event_id={event_id}/>
            {config && <Questions event_id={event_id} />}
        </div>
    </>
}